'use client'

import { SwitcherItemSkeleton } from '@maestro/commerce-blocks/components/switcher'

export default function SwitcherListSkeleton() {
  return (
    <ul className="switcher__list">
      {Array.from({ length: 3 }).map((_, index) => (
        <SwitcherItemSkeleton key={`switcher-item-skeleton-${index}`} />
      ))}
    </ul>
  )
}
